import { render, staticRenderFns } from "./CrearEntrenamiento.vue?vue&type=template&id=2f50497f&scoped=true&"
import script from "./CrearEntrenamiento.vue?vue&type=script&lang=js&"
export * from "./CrearEntrenamiento.vue?vue&type=script&lang=js&"
import style0 from "./CrearEntrenamiento.vue?vue&type=style&index=0&id=2f50497f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f50497f",
  null
  
)

export default component.exports